// Add your custom JS here.

import Glide from '@glidejs/glide';

window.Glide = Glide;